const STORAGE_KEY = "brixigo.settings.visitedPaths";

function readVisited() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed.map(String) : [];
  } catch {
    return [];
  }
}

function writeVisited(paths) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify([...new Set(paths.map(String))]));
  } catch {
    /* ignore quota / private mode */
  }
}

function normalizePath(path) {
  if (!path) return "";
  const base = String(path).split("?")[0].replace(/\/+$/, "") || "/";
  return base;
}

export function getVisitedSettingsPaths() {
  return readVisited();
}

export function isSettingsPathVisited(path) {
  const target = normalizePath(path);
  if (!target) return false;
  return readVisited().some((p) => normalizePath(p) === target);
}

export function markSettingsPathVisited(path) {
  const target = normalizePath(path);
  if (!target) return getVisitedSettingsPaths();
  const next = [...readVisited()];
  if (!next.some((p) => normalizePath(p) === target)) {
    next.push(target);
    writeVisited(next);
  }
  return next;
}

export function settingsVisitedStorageKey() {
  return STORAGE_KEY;
}
